import {
  LEGAL_COMPLIANCE_COUNTRY_CODES,
  LEGAL_PAYWALL_COUNTRY_CODES,
} from '~/shared/constants/legalConstants'
import {
  PaymentMethod,
  PaymentSystem,
} from '~/shared/constants/paymentConstants'
import { selectIsDirectStripePaymentEnabled } from '~/shared/store/payment/selects'
import { IAppState } from '~/shared/store/types'
import { IUserStatus } from '~/shared/types/userTypes'

export const selectUserUUID = (state: IAppState): string => state.user.uuid
export const selectUserStatus = (state: IAppState): IUserStatus | null =>
  state.user.status
export const selectUserEmail = (state: IAppState): string =>
  state.user.status?.email?.onboardingEmail || ''
export const selectUserCountryCode = (state: IAppState): string =>
  state.user.status?.countryCode || ''
export const selectIsLegalComplianceCountry = (state: IAppState): boolean =>
  LEGAL_COMPLIANCE_COUNTRY_CODES.includes(selectUserCountryCode(state))
export const selectIsLegalPaywallCountry = (state: IAppState): boolean =>
  LEGAL_PAYWALL_COUNTRY_CODES.includes(selectUserCountryCode(state))
export const selectUserUtmTags = (state: IAppState): Record<string, string> =>
  state.user.utmTags || state.user.status?.config?.utmTags || {}
export const selectUserPaymentMethod = (state: IAppState): PaymentMethod =>
  state.user.status?.config.paymentMethod || PaymentMethod.CREDIT_CARD
export const selectUserTrialPeriod = (state: IAppState): number =>
  state.user.status?.config.trialPeriod || 0
export const selectUserPaymentId = (state: IAppState): string =>
  state.user.status?.config?.paymentId || ''
export const selectUserPaymentSystem = (state: IAppState): PaymentSystem =>
  selectIsDirectStripePaymentEnabled(state)
    ? PaymentSystem.STRIPE
    : state.user.status?.config?.paymentSystem || PaymentSystem.STRIPE
export const selectHasAccountByEmail = (state: IAppState): boolean | null =>
  state.user.accountStatus.hasAccount

export const selectExistingUUIDByEmail = (state: IAppState): string =>
  state.user.accountStatus.existingUuid

export const selectHasAccessToAppByEmail = (state: IAppState): boolean | null =>
  state.user.accountStatus.hasAccessToApp

export const selectUserSavedPaymentMethod = (
  state: IAppState,
): IUserStatus['savedPaymentMethod'] =>
  state.user.status?.savedPaymentMethod ?? null
